const CF_FUNCTION_URL = 'https://southamerica-east1-camelia-69abc.cloudfunctions.net'

/**
 * Upload an image to Cloudflare Images via Cloud Function
 * @param {File} file - The image file to upload
 * @param {string} [variant] - Optional Cloudflare Images variant name to return
 *   the URL for (e.g. '1080x1350'). Defaults to 'public' on the backend.
 * @returns {Promise<string>} - The public URL of the uploaded image
 */
export async function uploadToCloudflare (file, variant) {
  const formData = new FormData()
  formData.append('file', file)
  if (variant) formData.append('variant', variant)

  const response = await fetch(`${CF_FUNCTION_URL}/cloudflare-uploadImage`, {
    method: 'POST',
    body: formData
  })

  const data = await response.json()

  if (data.error) {
    throw new Error(data.error)
  }

  return data.url
}

/**
 * Upload an image from a URL to Cloudflare Images via Cloud Function (for migration)
 * @param {string} url - The URL of the image to upload
 * @param {string} [variant] - Optional Cloudflare Images variant name to return
 *   the URL for (e.g. '1080x1350'). Defaults to 'public' on the backend.
 * @returns {Promise<string>} - The public URL of the uploaded image
 */
export async function uploadUrlToCloudflare (url, variant) {
  const response = await fetch(`${CF_FUNCTION_URL}/cloudflare-uploadImageFromUrl`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ url, variant })
  })

  const data = await response.json()

  if (data.error) {
    throw new Error(data.error)
  }

  return data.url
}
